// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"642":"173078a4","775":"67152498","980":"6172c455"}[chunkId] + ".chunk.js";
};